module.exports = __webpack_public_path__ + "img/新能源汽车行业结构示意图.e1263a9b.jpg";